var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0022 14H2.5C2.30101 14 1.5 14 1.28588 13.7249C1 13.5 1 12.9537 1 12.7547V2C1 1.80101 1 1.5 1.28588 1.2061C1.57175 0.912191 2.24917 1 2.5 1H6.0022V3.71386C6.0022 4.31082 6.23934 4.88333 6.66145 5.30544C7.08356 5.72755 7.65607 5.96469 8.25303 5.96469H10.5607C10.5607 6.16367 10.5829 6.35451 10.7236 6.49521C10.8643 6.63592 11.0551 6.71496 11.2541 6.71496C11.4531 6.71496 11.6439 6.63592 11.7847 6.49521C11.9254 6.35451 12.0044 6.16367 12.0044 5.96469V5.1694C11.9966 5.10047 11.9815 5.03257 11.9594 4.96682V4.8993C11.9233 4.82215 11.8752 4.75124 11.8168 4.68922L7.31518 0.187569C7.25316 0.12921 7.18225 0.0810906 7.10511 0.0450166C7.08029 0.0406721 7.0549 0.0406721 7.03008 0.0450166C6.96712 0.0221508 6.90162 0.00703409 6.83501 0H2.25083C1.65387 0 1.08136 0.23714 0.659252 0.659252C0.23714 1.08136 0 1.65387 0 2.25083V12.7547C0 13.3516 0.23714 13.9241 0.659252 14.3463C1.08136 14.7684 1.65387 15.0055 2.25083 15.0055H6.0022C6.20119 15.0055 6.39202 14.9265 6.53273 14.7858C6.67343 14.6451 6.75248 14.4542 6.75248 14.2552C6.75248 14.0562 6.72684 14.09 6.66145 14C6.5 14 6.20119 14 6.0022 14ZM7.03008 1.5L10.5 5L8.23987 4.96682C8.04088 4.96682 7.60029 4.91896 7.31518 4.63385C7.03008 4.34875 7 3.91285 7 3.71386L7.03008 1.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5H4",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.5H4",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.5H7",
    stroke: "black",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12L10.6001 10.3001",
    stroke: "black",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00073 11.9989L10.5993 13.7012",
    stroke: "black",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00439,
    cy: 12,
    r: 1,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0044,
    cy: 10,
    r: 1,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0044,
    cy: 14,
    r: 1,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.6e4dba0b87bb264939eddc97ccd6f9df.svg";
export { ForwardRef as ReactComponent };